(function () {
  'use strict';

  // Téma posiela pri pridaní aj pri zmene množstva ten istý event 'cart:update'.
  var EVENT_NAME = 'cart:update';

  function init() {
    var root = document.querySelector('[data-ao-added]');
    if (!root || root.dataset.aoAddedReady === 'true') return;
    root.dataset.aoAddedReady = 'true';

    var dialog = root.querySelector('.ao-added__dialog');
    var titleNode = root.querySelector('[data-ao-added-title]');
    var lastFocused = null;
    var hideTimer = null;

    function cartDrawerIsOpen() {
      var drawer = document.querySelector('cart-drawer-component dialog');
      return Boolean(drawer && drawer.open);
    }

    function isCartPage() {
      var path = String(window.location.pathname || '').replace(/\/+$/, '');
      return /\/cart$/i.test(path) || Boolean(document.querySelector('.ao-cart-page'));
    }

    function eventCameFromCart(detail) {
      var source = detail && detail.sourceId ? document.getElementById(detail.sourceId) : null;
      return Boolean(source && source.closest('.cart-drawer, .ao-cart-page, .main-cart'));
    }

    function close() {
      window.clearTimeout(hideTimer);
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      root.classList.remove('is-open');
      if (lastFocused && document.contains(lastFocused)) {
        try { lastFocused.focus({ preventScroll: true }); } catch (error) {}
      }
    }

    var AUTO_HIDE_MS = 0;

    function scheduleHide() {
      window.clearTimeout(hideTimer);
      if (AUTO_HIDE_MS > 0) hideTimer = window.setTimeout(close, AUTO_HIDE_MS);
    }

    function open(productTitle) {
      lastFocused = document.activeElement;
      if (titleNode) {
        titleNode.textContent = productTitle || '';
        titleNode.hidden = !productTitle;
      }
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
        if (dialog) {
          try { dialog.focus({ preventScroll: true }); } catch (error) {}
        }
      });
      /* V245: potvrdenie sa už samo nezatvára. Je v ňom ponuka, ktorú si
         človek nestihne prečítať za tri sekundy — zatvorí si ho sám. */
    }

    /* Pri skutočnej interakcii s panelom sa automatické zatvorenie odloží.
       Úvodné programové zaostrenie dialógu sa ignoruje — inak by časovač
       zrušilo hneď pri otvorení. */
    /* Zámerne pointermove, nie mouseenter: panel sa otvára uprostred
       obrazovky často priamo pod kurzorom, takže mouseenter by časovač
       zrušil hneď pri otvorení a potvrdenie by ostalo visieť navždy.
       Odložíme ho až pri skutočnom pohybe myši nad panelom. */
    root.addEventListener('pointermove', function () {
      if (!root.hidden) window.clearTimeout(hideTimer);
    });
    root.addEventListener('focusin', function (event) {
      if (event.target === dialog) return;
      window.clearTimeout(hideTimer);
    });
    root.addEventListener('pointerleave', function () { if (!root.hidden) scheduleHide(); });

    root.querySelectorAll('[data-ao-added-close]').forEach(function (node) {
      node.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (root.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener(EVENT_NAME, function (event) {
      var detail = (event && event.detail) || {};
      var data = detail.data || {};

      // Ochrana zásielky a darček sa pridávajú samy — tie sa nepotvrdzujú.
      if (data.source === 'ao-cart-benefits') return;
      if (data.didError) return;

      /* Potvrdzovací modal patrí k pridaniu z produktovej/katalógovej stránky.
         Na stránke košíka ani pri akcii priamo z košíka ho nezobrazujeme —
         pri množstve, ochrane, darčeku či prípadnom upselle by iba rušil. */
      if (isCartPage() || eventCameFromCart(detail)) return;

      /* Názov produktu: najprv z detailu udalosti, potom z prvku, ktorý
         pridanie spustil, a až nakoniec z nadpisu stránky. Fallback na
         prvý [data-product-title] v dokumente ukazoval pri pridaní
         z katalógu názov cudzieho produktu. */
      var title = detail.productTitle || (detail.data && detail.data.productTitle) || '';
      var source = detail.sourceId ? document.getElementById(detail.sourceId) : null;
      if (!title && source) {
        var scope = source.closest('[data-product-title]');
        if (scope) title = scope.getAttribute('data-product-title') || '';
        if (!title) {
          var card = source.closest('[data-ao-browser-card], .ao-product-card, .product-card');
          var cardTitle = card && card.querySelector('.ao-browser-card__title, h3, h2');
          if (cardTitle) title = cardTitle.textContent.trim();
        }
      }
      if (!title && document.querySelectorAll('[data-product-title]').length === 1) {
        title = document.querySelector('[data-product-title]').getAttribute('data-product-title') || '';
      }
      if (!title) {
        var heading = document.querySelector('.ao-product-title, .aoc5-intro__title');
        if (heading) title = heading.textContent.trim();
      }

      open(title);
    });
  }

  /* Návrat z natívneho odoslania formulára.

     Keď objednávka obsahuje nahratú fotografiu, musí ísť do košíka natívnym
     POSTom — cez AJAX by Shopify uložil iba názov súboru a grafika by sa
     stratila. Aby zákazník napriek tomu neskončil na stránke košíka,
     posielajú konfigurátory `return_to` späť na produkt s týmto príznakom.
     Tu ho zachytíme, ukážeme rovnaké potvrdenie ako pri AJAXe a príznak
     z adresy odstránime, nech sa nedostane do histórie ani do zdieľaného
     odkazu. */
  function confirmAfterNativeReturn() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (error) { return; }
    if (params.get('ao_added') !== '1') return;

    params.delete('ao_added');
    var rest = params.toString();
    try {
      window.history.replaceState({}, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
    } catch (error) { /* história sa nemusí dať prepísať, potvrdenie ukážeme aj tak */ }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            data: { source: 'ao-native-return', itemCount: Number(cart.item_count) || 0 }
          }
        }));
      })
      .catch(function () {});
  }

  function boot() {
    init();
    confirmAfterNativeReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
